import { render } from "./ShopBooking.vue?vue&type=template&id=4814b056&scoped=true"
import script from "./ShopBooking.vue?vue&type=script&lang=js"
export * from "./ShopBooking.vue?vue&type=script&lang=js"

import "./ShopBooking.vue?vue&type=style&index=0&id=4814b056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4814b056"]])

export default __exports__